/** @jsx jsx */
import { useContext } from 'react';
import { jsx } from '@emotion/core';

import { ChallengeResults, ChallengeResultsSection } from 'components';
import { ChallengeListDetailsContext } from '..';
import { useSelector } from 'react-redux';
import { productCurrencySelector } from 'reducers/app.reducer';
import { getResultUnit } from 'utils';

export default function ResultSection() {
  const { challenge } = useContext(ChallengeListDetailsContext);

  const lastDeclarationDate =
    challenge.currentChallengeMetaData?.lastValidatedDeclarationDate;

  const rewardUnit = useSelector(productCurrencySelector);
  const resultUnit = getResultUnit(challenge);
  const isGoalMecanicByProduct = !challenge?.isRewardingGlobal;
  const unitToDisplay = isGoalMecanicByProduct ? rewardUnit : resultUnit;

  return (
    <ChallengeResultsSection
      hasResult={!!challenge?.challengeResults}
      date={lastDeclarationDate}
    >
      <ChallengeResults
        areResultsVisible={challenge.areResultsVisible}
        disabled={false}
        goals={challenge.challengeGoals}
        goalType={challenge.goalType}
        unitToDisplay={unitToDisplay}
        userChallengeResults={challenge?.challengeResults}
        isGoalMecanicByProduct={isGoalMecanicByProduct}
      />
    </ChallengeResultsSection>
  );
}
